import React from 'react'
import { Link } from 'react-router-dom'

const MobileBottombar = () => {
    return (
        <>
            <footer className='mobile-footer rounded-tl-xl rounded-tr-xl z-[1000] bg-cover bg-no-repeat bg-[center_top] flex lg:hidden items-center h-[20vw] w-[100vw] fixed bottom-0 left-0 '>
                <ul className='flex items-center justify-between mt-[4vw]'>
                    <li className='w-[20vw] '>
                        <Link to="/cash_1" className='flex justify-center items-center flex-col pt-2.5' >
                            <i className='fi fi-rs-hand-holding-usd text-[#0078fb] text-2xl mb-0.5'></i>
                            <div className='text-center text-white font-bold text-xs'>충전</div>
                        </Link>
                    </li>
                    <li className='w-[20vw] '>
                        <Link to="/cash_2" className='flex justify-center items-center flex-col pt-2.5' >
                            <i className='fi fi-rs-hands-usd text-[#0078fb] text-2xl mb-0.5'></i>
                            <div className='text-center text-white font-bold text-xs'>환전</div>
                        </Link>
                    </li>
                    <li className='w-[20vw] '>
                        <Link to="/" className='flex justify-center items-center flex-col pt-2.5 text-[.81rem] w-[15.2vw] h-[15.2vw] rounded-full absolute top-[3.6vw] left-[42.4vw]  text-black bg-gradient-to-b from-[#01cbfb] to-[#0078fb]' >
                            <i className='fi fi-rs-home text-black  text-[28px] mb-[-5px]'></i>
                            <div className='text-center text-black font-bold text-xs'>홈</div>
                        </Link>
                    </li>
                    <li className='w-[20vw] '>
                        <Link to="/event" className='flex justify-center items-center flex-col pt-2.5' >
                            <i className='fi fi-rs-gift text-[#0078fb]  text-2xl mb-0.5'></i>
                            <div className='text-center text-white font-bold text-xs'>이벤트</div>
                        </Link>
                    </li>
                    <li className='w-[20vw] '>
                        <Link to="/customer" className='flex justify-center items-center flex-col pt-2.5' >
                            <i className='fi fi-rs-time-twenty-four text-[#0078fb] text-2xl mb-0.5'></i>
                            <div className='text-center text-white font-bold text-xs'>고객센터</div>
                        </Link>
                    </li>
                </ul>

            </footer>
        </>
    )
}

export default MobileBottombar